<template>
  <div class="invitation-content">
    <p class="invitation-code">您的邀请码是</p>
    <p class="invitation-code">{{ invitationCode }}</p>
    <p class="invitation-description">
      将您的邀请码告诉同学、朋友，您的好友注册、消费后，您将获得好友消费金额的10%作为奖励，具体规则请查看<a href="#" @click.prevent="viewInvitationMechanism">邀请机制</a>
    </p>
    <div class="button-container">
      <el-button type="primary" class="copy-button" @click="copyInvitationCode">复制邀请码</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    invitationCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.modelValue
    };
  },
  watch: {
    modelValue(newVal) {
      this.dialogVisible = newVal;
    },
    dialogVisible(newVal) {
      this.$emit('update:modelValue', newVal);
    }
  },
  methods: {
    viewInvitationMechanism() {
      // 处理查看邀请机制的逻辑
      console.log('查看邀请机制');
    },
    copyInvitationCode() {
      // 复制邀请码的逻辑
      if (!this.invitationCode) {
        this.$message.warning('邀请码为空');
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        // 使用现代浏览器的剪贴板 API
        navigator.clipboard.writeText(this.invitationCode)
          .then(() => {
            this.$message.success('邀请码已复制到剪贴板');
          })
          .catch(err => {
            console.error('复制邀请码失败:', err); // 打印错误信息
            this.$message.error('复制邀请码失败，请手动复制');
            this.fallbackCopyText(this.invitationCode);
          });
      } else {
        // 提供手动复制的降级方案
        this.fallbackCopyText(this.invitationCode);
      }
    },
    fallbackCopyText(text) {
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.value = text;
      input.select();
      if (document.execCommand('Copy')) {
        this.$message.success('邀请码已复制到剪贴板（降级方案）');
      } else {
        this.$message.error('复制邀请码失败，请手动复制');
      }
      document.body.removeChild(input);
    }
  }
};
</script>

<style scoped>
.invitation-content {
  text-align: center;
}

.invitation-code {
  font-size: 24px;
  margin: 20px 0;
}

.invitation-description {
  font-size: 16px; /* 调整字体大小 */
  margin: 20px 0;
}

/* 按钮容器居中 */
.button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;

}

.copy-button {
  width: 30%;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .invitation-content {
    padding: 20px 16px;
  }
  
  .invitation-code {
    font-size: 20px;
    margin: 16px 0;
  }
  
  .invitation-description {
    font-size: 14px;
    margin: 16px 0;
    line-height: 1.6;
  }
  
  .button-container {
    margin-top: 16px;
  }
  
  .copy-button {
    width: 100%;
    padding: 12px 20px;
    font-size: 16px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .invitation-content {
    padding: 24px 20px;
  }
  
  .invitation-code {
    font-size: 22px;
    margin: 18px 0;
  }
  
  .invitation-description {
    font-size: 15px;
    margin: 18px 0;
  }
  
  .copy-button {
    width: 50%;
    padding: 12px 24px;
    font-size: 15px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .invitation-content {
    padding: 16px 12px;
  }
  
  .invitation-code {
    font-size: 18px;
    margin: 12px 0;
  }
  
  .invitation-description {
    font-size: 13px;
    margin: 12px 0;
    line-height: 1.5;
  }
  
  .button-container {
    margin-top: 12px;
  }
  
  .copy-button {
    padding: 10px 16px;
    font-size: 15px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .invitation-content {
    padding: 20px 16px;
  }
  
  .invitation-code {
    font-size: 19px;
    margin: 14px 0;
  }
  
  .invitation-description {
    font-size: 14px;
    margin: 14px 0;
  }
  
  .copy-button {
    width: 60%;
    padding: 10px 20px;
    font-size: 14px;
  }
}
</style>